import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const PayverseResult = () => {
  return <CommonResult />;
};

export default PayverseResult;
